export const paperStyles = () => ({
  overflow: 'visible',
  filter: 'drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.32))',
  mt: 1.5,
  '&:before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: 0,
    right: 10,
    width: 10,
    height: 10,
    bgcolor: 'background.paper',
    transform: 'translateY(-50%) rotate(45deg)',
    zIndex: 0,
  },
  '.MuiMenuItem-root': {
    fontSize: '14px',
    '.MuiListItemIcon-root': {
      minWidth: 'auto',
      marginRight: '8px',
      svg: {
        width: '20px',
        height: '20px',
      },
    },
  },
});

export const notificationsTabsStyles = () => ({
  '.MuiTabs-indicator': {
    display: 'none',
    background: '#2845D2 !important',
  },
  '.MuiTabs-root': {
    padding: '0 8px',
    borderBottom: '1px solid rgba(75, 75, 75, 0.1)',
    minHeight: '36px',
  },
  '.dn-tab-custom + .dn-tab-custom': {
    marginLeft: '8px',
  },
  '.MuiTab-root': {
    borderWidth: '1px 1px 0px 1px',
    borderStyle: 'solid',
    borderColor: 'rgba(75, 75, 75, 0.1)',
    borderRadius: '10px 10px 0px 0px',
    padding: '0px 20px',
    cursor: 'pointer',
    textTransform: 'none !important',
    fontWeight: '400',
    color: '#4d4d4d',
    minWidth: '0 !important',
    minHeight: '36px !important',
    height: '36px !important',
    marginBottom: '0 !important',
    position: 'relative',
    zIndex: '9',
    '&.Mui-selected, &:hover': {
      background: 'rgba(29, 50, 153, 0.05)',
      color: '#4d4d4d',
    },
  },
  '.dn-tab-panel': {
    background: '#FFFFFF',
    boxSizing: 'border-box',
    borderRadius: '14px',
    display: 'flex',
    '&:empty': {
      display: 'none !important',
    },
    '& > div': {
      width: '100%',
    },
  },
});
